export type MarginItem = { id: string; top: number; height: number }

export function layoutMargin(items: MarginItem[], gap: number, pinned: string | null = null): Record<string, number> {
  const sorted = [...items].sort((a, b) => a.top - b.top)
  const placed: Record<string, number> = {}
  const pinIndex = pinned ? sorted.findIndex((item) => item.id === pinned) : -1
  if (pinIndex < 0) {
    let floor = -Infinity
    for (const item of sorted) {
      placed[item.id] = Math.max(item.top, floor)
      floor = placed[item.id] + item.height + gap
    }
    return placed
  }
  placed[sorted[pinIndex].id] = sorted[pinIndex].top
  let floor = sorted[pinIndex].top + sorted[pinIndex].height + gap
  for (const item of sorted.slice(pinIndex + 1)) {
    placed[item.id] = Math.max(item.top, floor)
    floor = placed[item.id] + item.height + gap
  }
  let ceiling = sorted[pinIndex].top - gap
  for (const item of sorted.slice(0, pinIndex).reverse()) {
    placed[item.id] = Math.min(item.top, ceiling - item.height)
    ceiling = placed[item.id] - gap
  }
  const overflow = Math.min(0, ...Object.values(placed))
  if (overflow < 0) {
    for (const id of Object.keys(placed)) placed[id] -= overflow
  }
  return placed
}
